"use client";

import dynamic from "next/dynamic";
import type { OrderWizardProps } from "./OrderWizard";

// The wizard restores an unfinished draft from the browser on first render,
// which the server can't know about — so it renders in the browser only.
const OrderWizard = dynamic(() => import("./OrderWizard"), {
  ssr: false,
  loading: () => <div className="min-h-screen bg-surface" />,
});

export default function OrderFormClient(props: OrderWizardProps) {
  return <OrderWizard {...props} />;
}
